/**
 * Layout analytics component
 * 
 */

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Functions

import Event from '../../../utils/functions/analytics';

export default class Analytics extends PureComponent {

	static propTypes = {

		location: PropTypes.object
	}

	componentWillReceiveProps(newProps) {

		if (newProps.location.pathname !== this.props.location.pathname) {

			this.componentTracking(newProps.location);
		}
	}

	componentDidMount() {

		const { location } = this.props;

		setTimeout(() => { this.componentTracking(location); }, 2000);
	}

	componentTracking(location) {

		setTimeout(() => { Event.page(location.pathname); }, 100);
	}

	render() {

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/analytics/analytics.js